import { call, put, delay } from "redux-saga/effects";
import { balanceApi } from "@services/api";
import { getAllEarningActions } from "../slices";

function* getAllEarningWorker({ payload }) {
  yield delay(300);
  try {
    yield put(getAllEarningActions.pending());
    const response = yield call(balanceApi.getAllEarning, payload);
    yield put(getAllEarningActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllEarningActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllEarningWorker };
